import React from 'react';
import styled from 'styled-components';

const Spinner = styled.img`
  position: relative;
  width: 48px;
  height: 48px;
`;

export default Spinner;
